module.exports = __webpack_public_path__ + "static/media/de_mirage.33b86ce7.jpg";